var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"DFooterExpandPanel",class:{ 'DFooterExpandPanel--show': _vm.show }},[(_vm.show)?_vm._t("default"):_vm._e()],2),_vm._v(" "),(_vm.show)?_c('div',{staticClass:"DFooterExpandPanel__keepSpace"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }